import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { numberFormat } from './util/util';

import logo from '../assets/logo.png';

export default ({ paymentOrder }) => {
  const amountString = numberFormat(paymentOrder.amount, paymentOrder.currency);
  return (
    <div>
      <Paper className="container" style={{ padding: '0 15px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={2}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={logo} alt="logo" />
                  &nbsp;&nbsp;
                  <h2 style={{ padding: 0, margin: 0 }}>Stamurai</h2>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell style={{ textAlign: 'right' }}>ID:</TableCell>
              <TableCell>{paymentOrder.orderId}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ textAlign: 'right' }}>Amount:</TableCell>
              <TableCell>{amountString}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ textAlign: 'right' }}>Payment Status:</TableCell>
              <TableCell>{paymentOrder.isPaid ? 'Paid' : 'Pending'}</TableCell>
            </TableRow>
            {
              paymentOrder.isPaid
                ? (
                  <TableRow>
                    <TableCell style={{ textAlign: 'right' }}>Payment Date:</TableCell>
                    <TableCell>{paymentOrder.paymentDate && new Date(paymentOrder.paymentDate).toLocaleDateString()}</TableCell>
                  </TableRow>
                ) : null
            }
            <TableRow>
              <TableCell style={{ textAlign: 'right' }}>Payment Mode:</TableCell>
              <TableCell>{paymentOrder.mode}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ textAlign: 'right' }}>Order Date:</TableCell>
              <TableCell>{paymentOrder.orderDate && new Date(paymentOrder.orderDate).toLocaleDateString()}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ textAlign: 'right' }}>Total Sessions:</TableCell>
              <TableCell>{paymentOrder.sessions}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ textAlign: 'right' }}>Sessions Validity:</TableCell>
              <TableCell>{`${paymentOrder.recurringSessionsFrequencyDays * paymentOrder.recurringNumber} days`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
};
